import react ,{useEffect , useState,useRef} from 'react'
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput,
  DynamicCellInput,
  DynamicDialogInput,
  DynamicEmailInput
} from '../software-dynamic-version-3/mainSection-multiple-inputs-v-3';
import DynamicInputGrid from '../software-dynamic-version-3/popup-input-grid-v-3';
import SecurityService from '../security/security.service';
import voucherService from './voucher.service';
import moment from 'moment';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';

import receivableAccountsInput from '../setup-inputs/receivable-accounts/receivable-accounts-list';
const GetBills = (props) => {
  console.log(props)
let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent , DynamicTextInput: TextComponent ,DynamicCheckBoxInput:CheckBoxComponent , DynamicHiddenInput : HiddenComponent , DynamicButtonInput:ButtonComponent} = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput ,DynamicTextInput , DynamicCheckBoxInput,DynamicHiddenInput,DynamicButtonInput};
const updateMainSecionsValue = (valueObj) => {
    setInputProps((prevValues) => {
      const updatedValues = { ...prevValues };
  
      Object.keys(valueObj).forEach((key) => {
        if (updatedValues[key]) {
          updatedValues[key] = {
            ...updatedValues[key],
            ...valueObj[key], // Spread the inner object to update its properties
          };
        }
      });
  
      return updatedValues;
    });
  };
  
  
  const [inputProps, setInputProps] = useState({
  
    CallGridDataSource:{name: 'CallGridDataSource',   value: true },
    GridDataSource:{name: 'GridDataSource',   value: [] },

    SelectRowByID:{name: 'SelectRowByID',   value: undefined },

    AccountTitleCashBank:{
      name:{id:'AccountIDCashBank',value:'AccountTitleCashBank'},
      caption: 'Select Account',
      value:{id: props.AccountIDCashBank || undefined ,value:props.AccountTitleCashBank || ''},
      dataSource: {type:'Route',route:props.Type == 'PV' ?  'VoucherAccountPayable' : 'VoucherAccountReceivable'},
      
      // isControlBlur:true
        },
    
    GetBill:{name:'GetBill', caption:'Get Bill', isClicked:false ,enabled:true},

    BalanceAmount:{name:'BalanceAmount',caption:'Balance Amount',value:0,enabled:false},
    ReceivedAmount:{name:'ReceivedAmount',caption:'Received Amount',value:0,formula:`BalanceAmount - DifferenceAmount`},
    DifferenceAmount:{name:'DifferenceAmount',caption:'Difference Amount',value:0,formula:`BalanceAmount - ReceivedAmount`,enabled:false},

    Adjust:{name:'Adjust', caption:'Adjust', isClicked:false ,enabled:false},
    Reset:{name:'Reset', caption:'Reset', isClicked:false ,enabled:true},

      }
    );

    // EXTRA CODE START
    const updateDetails = (data) =>{
      setTimeout(() => {
        props.sendDetails(data)
      }, 400);
    }

    // useEffect(()=>{
    //   return ()=>{
    //   props.sendDetails([...inputProps.GridDataSource.value])
    //   }
    // },[])
    
// EXTRA CODE END

const handleInputCreated = async (e, name) => {
  console.log(e);
    console.log(`Input ${name} changed to ${e}`);
  };
const handleInputFocus = async (e, name) => { 
  if(name == 'AccountTitleCashBank' ){
    updateMainSecionsValue({GetBill:{enabled:true,isClicked:false}});
  }else if(name == 'ReceivedAmount'){
    updateMainSecionsValue({Adjust:{enabled:true}});
  }
    console.log(e);
    console.log(`Input ${name} focus to ${e}`);
  };
const handleInputChange = async (value, name) => {
   
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
const handleInputBlur = async  (value, name) => {
  if(name == 'AccountTitleCashBank' ){
    document.getElementById('GetBill').focus()
  }
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };

  const handleInputClicked = async (name) => {
    
    if(name =='GetBill'){
      callGridDataSource()
    }else if(name == 'Reset'){
      callGridDataSource()
      setTimeout(()=>updateMainSecionsValue({Reset:{enabled:true}}),500)
    }else if(name == 'Adjust'){
      adjustGridDataSource()

      
    }
    console.log(`Input ${name}`);
  };
  let inputsList = [
    {Input: DropdownComponent,Props: {...inputProps.AccountTitleCashBank,setInputProps,onFocus:handleInputFocus,onBlur:handleInputBlur},ColumnSize:6},
    
    {Input:HiddenComponent,Props: {name:'Space1',setInputProps },ColumnSize:3},
    { Input: NumberComponent,Props: {...inputProps.BalanceAmount, setInputProps },ColumnSize:2},
    { Input: ButtonComponent,Props: {...inputProps.Reset, setInputProps,onClick:handleInputClicked  },ColumnSize:1},
    
    { Input: ButtonComponent,Props: {...inputProps.GetBill, setInputProps,onClick:handleInputClicked },ColumnSize:2},
    {Input:HiddenComponent,Props: {name:'Space2',setInputProps },ColumnSize:7},
    { Input: NumberComponent,Props: {...inputProps.ReceivedAmount, setInputProps,onFocus:handleInputFocus },ColumnSize:2},
    { Input: ButtonComponent,Props: {...inputProps.Adjust, setInputProps ,onClick:handleInputClicked },ColumnSize:1},
    
    {Input:HiddenComponent,Props: {name:'Space3',setInputProps },ColumnSize:9},
    { Input: NumberComponent,Props: {...inputProps.DifferenceAmount, setInputProps },ColumnSize:2},
    {Input:HiddenComponent,Props: {name:'Space1',setInputProps },ColumnSize:1},

    
    

  ];


  


    useEffect(()=>{
        console.log(props);
        updateMainSecionsValue({CallGridDataSource:{value:false}})        
    },[])

const adjustGridDataSource =  async ()=>{

  let GridDataSource = [...inputProps.GridDataSource.value]
  if(GridDataSource){
    let PropsReceivedAmount = Number(inputProps.ReceivedAmount.value) || 0

    let updateColumns  = GridDataSource.map((item) => {
      const receivedAmount = PropsReceivedAmount <= item.BalAmt  ? PropsReceivedAmount : PropsReceivedAmount > item.BalAmt ?  item.BalAmt:  PropsReceivedAmount;
      const differenceAmount = item.BalAmt - receivedAmount;

  // Update PropsReceivedAmount after calculating
  PropsReceivedAmount = PropsReceivedAmount -  receivedAmount;
      return {
        ...item,
        IsAdjust: false,
        ReceivedAmount:receivedAmount,
        DifferenceAmount:differenceAmount,
        Debit:  props.Type == 'RV' ? 0 : props.Type == 'PV' ? receivedAmount : 0,
        Credit: props.Type == 'PV' ? 0 : props.Type == 'RV' ? receivedAmount : 0,
        DetailRemarks: '-',
        PurchaseInvoiceID: props.Type === 'RV' || props.Type === 'JV' ? null : item.InvoiceID == undefined ? null : item.InvoiceID,
        SaleInvoiceID: props.Type === 'PV' || props.Type === 'JV' ? null : item.InvoiceID == undefined ? null : item.InvoiceID,
        VoucherDetailID: item?.VoucherDetailID,
        IsAdjust: false
      };
    });
    // console.log(GridDataSource)
    let balanceAmount = updateColumns.reduce((total, item) => total + Number(item.BalAmt), 0);
    updateMainSecionsValue({BalanceAmount:{value:balanceAmount}})
    
    let receivedAmount = updateColumns.reduce((total, item) => total + Number(item.ReceivedAmount), 0);
    updateMainSecionsValue({ReceivedAmount:{value:receivedAmount}})
    
    let differenceAmount = balanceAmount - receivedAmount;
    updateMainSecionsValue({DifferenceAmount:{value:differenceAmount}})
    
    // updateDetails([...updateColumns])
    let updateSendDetails = [...updateColumns];

        let updatedSendDetails = updateSendDetails.filter((row,index)=>{
          return row.ReceivedAmount > 0 ;
        })
        console.log(updatedSendDetails);
        updateDetails([...updatedSendDetails])

    updateMainSecionsValue({CallGridDataSource:{value:true}})
    
    updateMainSecionsValue({GridDataSource:{value:[...updateColumns]}})
      
    setTimeout(()=>updateMainSecionsValue({CallGridDataSource:{value:false}}),400)
    
    document.querySelector(`#GetBills`).style.visibility='visible';

//     if(updateColumns.length > 0){
//   setTimeout(()=>updateMainSecionsValue({SelectRowByID:{value:0}}),400)
//     setTimeout(()=> {
//         document.getElementById('VoucherDetailBillGrid_edit').click()
//     },600)

// setTimeout(()=>updateMainSecionsValue({SelectRowByID:{value:undefined}}),500)
// }

  }else{
    updateMainSecionsValue({GridDataSource:{value:[]}})
  }


}

const callGridDataSource =  async (id)=>{

  let data ={
    CompanyID:SecurityService.getCompanyIDLoggedInUserId(),
	VoucherType:props.Type == 'PV'?'PA':props.Type == 'JV'?'JA':props.Type == 'RV'?'RA':props.Type,
	// VoucherType:'PA',
	ToDate:moment().format('DD-MMM-YY'),
	AccountID:inputProps.AccountTitleCashBank.value.id,
	InvoiceID:0,
    FromDate:'01-JAN-01' ,
    }
    console.log(data)
  let response =await voucherService.getBills(data)
  console.log(response)
  if(response && response.data.recordset){

    let updateColumns  = response.data.recordset.map((item) => {
      return {
        ...item,
        BalAmt: item.BalAmt,
        IsAdjust: false,
        ReceivedAmount:0,
        DifferenceAmount:item.BalAmt,
        Debit: 0,
        Credit: 0,
        DetailRemarks:  '-',
        PurchaseInvoiceID: props.Type === 'RV' || props.Type === 'JV' ? null : item.InvoiceID == undefined ? null : item.InvoiceID,
        SaleInvoiceID: props.Type === 'PV' || props.Type === 'JV' ? null : item.InvoiceID == undefined ? null : item.InvoiceID,
        IsAdjust: false
      };
    });
    // console.log(response.data.recordset)
    let balanceAmount = updateColumns.reduce((total, item) => total + item.BalAmt, 0);
    updateMainSecionsValue({BalanceAmount:{value:balanceAmount}})
    
    let receivedAmount = updateColumns.reduce((total, item) => total + item.ReceivedAmount, 0);
    updateMainSecionsValue({ReceivedAmount:{value:receivedAmount}})
    
    let differenceAmount = balanceAmount - receivedAmount;
    updateMainSecionsValue({DifferenceAmount:{value:differenceAmount}})
    
    updateMainSecionsValue({CallGridDataSource:{value:true}})
    
    updateMainSecionsValue({GridDataSource:{value:[...updateColumns]}})
      
    updateDetails([])
    setTimeout(()=>updateMainSecionsValue({CallGridDataSource:{value:false}}),400)
  
    if(response.data.recordset.length > 0){
  setTimeout(()=>updateMainSecionsValue({SelectRowByID:{value:0}}),400)
    setTimeout(()=> {
        document.getElementById('VoucherDetailBillGrid_edit').click()
    },600)

setTimeout(()=>updateMainSecionsValue({SelectRowByID:{value:undefined}}),500)
}

  }else{
    updateMainSecionsValue({GridDataSource:{value:[]}})
  }


}
    
let addColumns =[
  { field:"AgingType",headerText:'Aging Type',width:'135px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},
  { field:"ToDate",headerText:'ToDate',width:'135px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},
  { field:"CompanyName",headerText:'Company Name',width:'135px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},
  { field:"CompanyID",headerText:'Company ID',width:'135px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},
  
  { field:"BillNo",headerText:'Bill No',width:'120px',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false}]},
  
  { field:"AccountTitle",headerText:'Account Title',width:'135px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},
  { field:"AccountID",headerText:'Account ID',width:'135px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},
  
  { field:"InvoiceID",headerText:'Invoice ID',width:'80px',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false}]},
  { field:"InvoiceDate",headerText:'Invoice Date',width:'110px',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false,editType:'datepickeredit'}]},
  
  { field:"Ttype",headerText:'T type',width:'10px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},
  
  { field:"Qty",headerText:'Qty',width:'80px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n0','editType':'numericedit',edit:{format:'n0'},allowEditing:false}]},
  { field:"BillAmt",headerText:'Bill Amt',width:'90px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n0','editType':'numericedit',edit:{format:'n0'},allowEditing:false}]},
  { field:"STaxPer",headerText:'S Tax %',width:'80px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n2','editType':'numericedit',edit:{format:'n2'},allowEditing:false}]},
  { field:"TaxAmt",headerText:'Tax Amt',width:'90px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n2','editType':'numericedit',edit:{format:'n2'},allowEditing:false}]},
  { field:"TotalAmt",headerText:'Total Amt',width:'90px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n0','editType':'numericedit',edit:{format:'n0'},allowEditing:false}]},
  { field:"PaymentAmt",headerText:'Payment Amt',width:'90px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n0','editType':'numericedit',edit:{format:'n0'},allowEditing:false}]},
    
  { field:"PaymentDays",headerText:'Payment Days',width:'90px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n0','editType':'numericedit',edit:{format:'n0'},allowEditing:false}]},
    
  { field:"DueDate",headerText:'Due Date',width:'110px',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false,editType:'datepickeredit'}]},
  { field:"DueDays",headerText:'Due Days',width:'70px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n0','editType':'numericedit',edit:{format:'n0'},allowEditing:false}]},
  
  { field:"BalAmt",headerText:'Balance Amt',width:'100px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n0','editType':'numericedit',edit:{format:'n0'},allowEditing:false}]},
  { field:"IsAdjust",headerText:'Adjust',width:'130px',textAlign:'left' ,headerTextAlign:'center',other:[{editType:'booleanedit',onChange:(checked, args, key)=>{

    console.log(checked, args, key)
  }}]},
  // { field:"Adjust",headerText:'Adjust',width:'100px',textAlign:'left' ,headerTextAlign:'center',other:[{'editType':'dropdownedit',edit:{
  //   caption:'Adjust' ,source:{type:"Data",dataSource:[
  //     {id:1,value:'YES'},
  //     {id:2,value:'NO'}
  //   ]} , field:{id:'AdjustID',value:'Adjust'}, filter:{},
  //   // select:{source:{type:'Function',dataSource:{function:voucherService.getMultiDropDownSource , params :[{type:'Value',source:'Stock'},{type:'Value',source:'0'},{type:'Value',source:'01-JUN-24'},{type:'Value',source:moment().format('DD-MMM-YY')},{type:'Column',source:'BrandID'}] , dropDownKey:'ProductID'}}},
  // },
  // template:(e)=>{
  //   console.log(e)
  //   let value = e.Adjust == true || e.Adjust == 'YES' ? 'YES' : 'NO'
  //   return(
  //     value  
  //   )
  // }
  // }]},
  { field:"ReceivedAmount",headerText:'Received Amount',width:'100px',textAlign:'left' ,headerTextAlign:'center',other:[{initialValue:0.00,'format':'n0','editType':'numericedit',edit:{format:'n0'},allowEditing:true}]},
  { field:"DifferenceAmount",headerText:'Difference Amount',width:'100px',textAlign:'left' ,headerTextAlign:'center',other:[{initialValue:0.00,'format':'n0','editType':'numericedit',edit:{format:'n0'},allowEditing:true}]},
    
  // { field:"Credit",headerText:'Credit',width:'130px',textAlign:'right' ,headerTextAlign:'center',other:[{initialValue:0.00 , 'format':'n2','editType':'numericedit',edit:{format:'n2'},'visible':props.Type == 'JV' || props.Type == 'RV'}]},
  
  { field:"DetailRemarks",headerText:'Detail Remarks',width:'100px',textAlign:'left' ,headerTextAlign:'center',other:[{initialValue:'-',endEdit:true}]},
]

 const tooltipRef = useRef(null);
  
 const showTooltip = (target, message) => {
  console.log(target)
  if (tooltipRef.current) {
    tooltipRef.current.destroy(); // Destroy existing tooltip if any
  }
  tooltipRef.current = new TooltipComponent({
    content: `<span class="error-tooltip">${message}</span>`,
    position: 'TopCenter',
  });
  tooltipRef.current.appendTo(target);
  tooltipRef.current.open(target);
};
  const hideTooltip = () => {
    if (tooltipRef.current) {
      tooltipRef.current.close(); // Close the tooltip
      tooltipRef.current.destroy(); // Destroy the tooltip instance
      tooltipRef.current = null; // Reset the ref
    }
  };
  
const addActionComplete = async (grid, args ,setDataSourceState ,getListService  , selectedRow, selectRowByID,
      startEdit,
      addUserLog,
      editUserLog,
      dataSourceStateLength )=>{
    
  console.log(args)
  if(args.requestType == 'add' || args.requestType == 'beginEdit'){
    document.getElementById('VoucherDetailBillGridIsAdjust').value = args.rowData.IsAdjust || false

      
      // updateMainSecionsValue({Adjust:{enabled:false}})
    document.querySelector(`#GetBills`).style.visibility='hidden';
  
const checkbox = document.getElementById('VoucherDetailBillGridIsAdjust');

if(checkbox) {
  
  checkbox.addEventListener('input', (e) => {
    
   console.log(args.rowData.IsAdjust)
    
    if(args.rowData.IsAdjust == false){

      document.getElementById('VoucherDetailBillGridReceivedAmount').value = 0
      args.form[23].ej2_instances[0].value = 0
      
      document.getElementById('VoucherDetailBillGridDifferenceAmount').value = args.rowData.BalAmt
      args.form[25].ej2_instances[0].value = args.rowData.BalAmt

    }else{
      
      document.getElementById('VoucherDetailBillGridReceivedAmount').value = args.rowData.BalAmt
      args.form[23].ej2_instances[0].value = args.rowData.BalAmt
      document.getElementById('VoucherDetailBillGridDifferenceAmount').value = 0
      args.form[25].ej2_instances[0].value =0
    }
  });
} else {
  console.warn('Checkbox with id "VoucherDetailBillAdjust" not found.');
}

    
// MAINTAIN RECEIVED AND DIFFERENCE AMOUMT ACCORRDING TO BALANCE AMOUNT

const calculateReceivedAmmountAccordingToBalanceAmount = () =>{
        setTimeout(() => {
          let DifferenceAmount = parseInt(document.getElementById(`VoucherDetailBillGridDifferenceAmount`).value.replace(/,/g, '') || 0)
      let BalanceAmount = parseInt(document.getElementById(`VoucherDetailBillGridBalAmt`).value.replace(/,/g, '') || 0)
  
  
         let receivedAmount = (BalanceAmount - DifferenceAmount).toFixed(0) ;
  
        console.log(receivedAmount);
  
        document.getElementById(`VoucherDetailBillGridReceivedAmount`).value = receivedAmount;
        args.form[23].ej2_instances[0].value = receivedAmount
  
}, 100);
      }
      
      
      document.getElementById('VoucherDetailBillGridReceivedAmount').addEventListener('blur',async (e)=>{
        console.log(e)
        let ReceivedAmount = parseInt(document.getElementById(`VoucherDetailBillGridReceivedAmount`).value.replace(/,/g, '') || 0)
          
          let BalanceAmount = parseInt(document.getElementById(`VoucherDetailBillGridBalAmt`).value.replace(/,/g, ''))
        if(ReceivedAmount > BalanceAmount){
          document.getElementById(`VoucherDetailBillGridReceivedAmount`).focus();
          document.getElementById(`VoucherDetailBillGridReceivedAmount`).select();
          // showTooltip(document.getElementById(`VoucherDetailBillGridReceivedAmount`), '');
          showTooltip(e.target, `<span class="error-tooltip"> Received Amount Cannot Greater then Balance Amount </span>`);
        
        }else{
          setTimeout(() => {
            hideTooltip()
          }, 100);
        }
      })
    
      
      document.getElementById('VoucherDetailBillGridDifferenceAmount').addEventListener('blur',async (e)=>{
        console.log(e)
        let ReceivedAmount = parseInt(document.getElementById(`VoucherDetailBillGridReceivedAmount`).value.replace(/,/g, '') || 0)
        let DifferenceAmount = parseInt(document.getElementById(`VoucherDetailBillGridDifferenceAmount`).value.replace(/,/g, '') || 0)
          
          let BalanceAmount = parseInt(document.getElementById(`VoucherDetailBillGridBalAmt`).value.replace(/,/g, ''))
        if(DifferenceAmount > BalanceAmount){
          document.getElementById(`VoucherDetailBillGridDifferenceAmount`).focus();
          document.getElementById(`VoucherDetailBillGridDifferenceAmount`).select();
          // showTooltip(document.getElementById(`VoucherDetailBillGridReceivedAmount`), '');
          showTooltip(e.target, `<span class="error-tooltip"> Difference Amount Cannot Greater then Balance Amount </span>`);
          
        }else{
          setTimeout(() => {
            hideTooltip()
          }, 100);
          
          
        }
      })
    
      const calculateDifferenceAmmountAccordingToBalanceAmount = () =>{
        setTimeout(async () => {
          
          let ReceivedAmount = parseInt(document.getElementById(`VoucherDetailBillGridReceivedAmount`).value.replace(/,/g, '') || 0)
          
          let BalanceAmount = parseInt(document.getElementById(`VoucherDetailBillGridBalAmt`).value.replace(/,/g, ''))
          // await checkBalanceAmount(ReceivedAmount,BalanceAmount)
  let differenceAmount =(BalanceAmount -  ReceivedAmount).toFixed(0) ;
  
  console.log(differenceAmount);
  
  document.getElementById('VoucherDetailBillGridDifferenceAmount').value = differenceAmount
  args.form[25].ej2_instances[0].value =differenceAmount;
}, 600);
      }
      
      document.getElementById('VoucherDetailBillGridReceivedAmount').addEventListener('input',calculateDifferenceAmmountAccordingToBalanceAmount)
      document.getElementById('VoucherDetailBillGridReceivedAmount').addEventListener('keydown',calculateDifferenceAmmountAccordingToBalanceAmount)
      
      document.getElementById('VoucherDetailBillGridDifferenceAmount').addEventListener('input',calculateReceivedAmmountAccordingToBalanceAmount)
      document.getElementById('VoucherDetailBillGridDifferenceAmount').addEventListener('keydown',calculateReceivedAmmountAccordingToBalanceAmount)
      

       
              // document.getElementById(`VoucherDetailBillGridDetailRemarks`).addEventListener('keydown',(tab)=>{
              //    tab.stopPropagation()
              //   if(tab.code == 'Tab' ||  tab.key == 'Tab' ){
              //     setTimeout(() => {
              //       document.getElementById('VoucherDetailBillGrid_update').click()

              //     },300)
              //   }
              // })
      
    }
  
  console.log(inputProps)
  
  
  console.log(args)
  console.log(selectedRow)
  if(args.requestType == 'save' || args.requestType == 'cancel'){
    // document.getElementById('VoucherGrid_dialogEdit_wrapper_dialog-content').scrollBottom = 0;
    document.querySelector(`#GetBills`).style.visibility='visible';


}
  if(args.requestType == 'save'){
    let inputProp = {}
        setInputProps((prevValues) => {
          console.log(prevValues);
          inputProp = prevValues
          return {...prevValues
          // ['MainInvoiceID']: {...prevValues['MainInvoiceID'] ,value :response.data.MainInvoiceID }    
        }});
    console.log(inputProp)


    if (args.action === 'edit') {
      
        // Case 2: MainVoucherID is undefined — update the existing item at the same index
        let gridData = [...(inputProp.GridDataSource.value || [])];
        
        gridData[args?.rowIndex] = {
          ...args.data,
          AccountTitle: args.data.AccountTitle,
          AccountID: args.data.AccountID,
          Debit:  props.Type == 'RV' ? 0 : props.Type == 'PV' ? args.data.ReceivedAmount || 0 : 0,
          Credit: props.Type == 'PV' ? 0 : props.Type == 'RV' ? args.data.ReceivedAmount || 0 : 0,
          DetailRemarks: args.data.DetailRemarks || '-',
          PurchaseInvoiceID: props.Type === 'RV' || props.Type === 'JV' ? null : args.data.InvoiceID == undefined ? null : args.data.InvoiceID,
          SaleInvoiceID: props.Type === 'PV' || props.Type === 'JV' ? null : args.data.InvoiceID == undefined ? null : args.data.InvoiceID,
          VoucherDetailID: args.data?.VoucherDetailID,
          IsAdjust: args.data.IsAdjust
        };
        
        
        let updateSendDetails = [...gridData];

        let updatedSendDetails = updateSendDetails.filter((row,index)=>{
          return row.ReceivedAmount > 0  
        })
        console.log(updatedSendDetails);
        updateDetails([...updatedSendDetails])
          setTimeout(()=>{
          updateMainSecionsValue({CallGridDataSource: {value:true},
            GridDataSource: {value:[...gridData]}
          })
        },400)
          
        setTimeout(()=>updateMainSecionsValue({CallGridDataSource: {value:false},}),600)
        let balanceAmount = gridData.reduce((total, item) => total + item.BalAmt, 0);
        updateMainSecionsValue({BalanceAmount:{value:balanceAmount}})
        let receivedAmount = gridData.reduce((total, item) => total + item.ReceivedAmount, 0);
        updateMainSecionsValue({ReceivedAmount:{value:receivedAmount}})
        let differenceAmount = balanceAmount - receivedAmount;
        updateMainSecionsValue({DifferenceAmount:{value:differenceAmount}})
        updateMainSecionsValue({Reset:{enabled:true}})

    var gridLength =gridData.length;

          setTimeout(() => {
            let  rowsInd = args.rowIndex +1;
          if(rowsInd < gridLength){
            selectRowByID(rowsInd)
            startEdit() 
        }}, 1000);




        }

    }

      }

    return (
        <div>
                  <StructuredGenerate   mainProps={props} title={``} Inputs={inputsList}/>

          <br/>
          <DynamicInputGrid
                  Id='VoucherDetailBill'
                  
                  ColumnsList={addColumns}
                  GridDataSource= {[
                    {
                  DataSourceType:inputProps.CallGridDataSource.value == true ? 'Data' : 'REST',
                  DataSource:  inputProps.GridDataSource.value,
                  // CreateColumns: [{columnName:'IsEdit',columnValue:false}]
                   }]
            }
                  DefaultSortedColumnName={''}
                  SelectRowByID={inputProps.SelectRowByID.value}

                  ListActionComplete={addActionComplete}
                  
                  ToolbarClicking ={(grid,args,selectedRows,getListService,saveData,dataSource)=>{
                    console.log(grid.dataSource)
                    console.log(args)
                    console.log(selectedRows)
                    console.log(getListService)
                    console.log(saveData)
                    console.log(dataSource)
                    }          
          
                  }
                  //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
                  AllowTemplate={false}
                  ToolbarOption={['Edit','Update','Cancel']}
                  AllowGrouping={false}
                  AllowExcelExport={false}
                  AllowPdfExport={false} 
                  ShowColumnChooser={false}
                  AllowFiltering={false}
                  AllowPaging={false}
                  
                  AllowDataBound={false}
                  ListSecurity={'ListSecurity'}
                  // AddSecurity={'VoucherList'}
                  EditSecurity={true}
                  // DeleteSecurity={'VoucherList'}
                  // DefaultSortedColumnSort={'Descending'}
                  FilterColumns={[]} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
                  GroupColumns={[]} 
                  // ListDelete={[]}
                  // DeleteType={'hard'} 
                  GridEditSettingMode={'Normal'}
                  GridEditSettingHeaderTemplate={'<p></p>'}
                  // GridSumColumns={[]}
                  AllowGridSum={false}
                  EditActionCompleteType={'Add'}
                      {...props}
                      ></DynamicInputGrid>
        </div>
    )
}

export default GetBills
